import { FeatureSettings } from '@graphql/gql/graphql';

export type RequiredFeatureSettings = Pick<FeatureSettings, 'id' | 'isEnabled' | 'metadata'>;

/**
 * @description Takes an array of featureSettings and featureId and returns the metadata of that enabled feature
 * if feature is not enabled, returns the empty metadata
 */
export default function getFeatureMetadata(
  featureSettings: RequiredFeatureSettings[],
  featureId: string
): Record<string, unknown> {
  if (!featureId) {
    return {};
  }
  try {
    const metaString =
      (featureSettings.find(feature => feature.isEnabled && feature.id === featureId) || {}).metadata || '{}';
    return JSON.parse(metaString);
  } catch {
    return {};
  }
}
